"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tfs_css_variables_1 = __importDefault(require("tfs.css-variables"));
var getColor = function (type) {
    switch (type) {
        case 'active':
            return tfs_css_variables_1.default.colorBlue;
        case 'main':
            return tfs_css_variables_1.default.colorGreen;
        default:
            return tfs_css_variables_1.default.colorGrayB;
    }
};
exports.default = {
    item: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        marginRight: '2rem',
        padding: 0,
        border: 'none',
        backgroundColor: 'transparent',
        fontSize: 'inherit',
        fontFamily: 'inherit',
        color: 'inherit',
        '&:hover, &:focus': {
            textDecoration: 'underline',
        },
        '& > *': {
            textDecoration: 'none',
            color: function (props) {
                return props.active ? getColor('active') : getColor(props.type);
            },
            fontSize: function (props) { return (props.type === 'main' ? '1.2rem' : undefined); },
            fontWeight: function (props) { return (props.type === 'main' || props.active) && 'bold'; },
        },
    },
    active: {
        '& > *': {
            color: tfs_css_variables_1.default.colorBlue,
            fontWeight: 'bold',
        },
    },
};
//# sourceMappingURL=NavigationItem.styles.js.map